import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerandering = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="m24 6 10 8-10 8v-4H7v-8h17z"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M16 18 6 26l10 8v-4h17v-8H16z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M13.316 24.5h12.5v-1h-11.5V21L5 27.987l5.504 4.403.625-.78-4.496-3.597L13.316 23zM26.5 13.89H14v1h11.5v2.5l9.316-6.987L29.312 6l-.624.78 4.496 3.598L26.5 15.39z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerandering);

export default ForwardRef;
